import Link from 'next/link';
import { useRouter } from 'next/router';
import { ReactSVG } from 'react-svg';
import { useTranslation } from 'utils/i18n';
import { getVenueImage } from 'utils/venueImages';

interface FavouriteVenueData {
  id: number;
  name: string;
  images?: { thumbnail?: string[]; regular?: string[] };
}

const FavouriteVenue = ({
  venue,
  onRemove,
}: {
  venue: FavouriteVenueData;
  onRemove: () => void;
}) => {
  const { t } = useTranslation('common');
  const router = useRouter();

  const onBookNow = () => {
    router.push(`/properties/${venue.id}#venue-rooms-section`);
  };

  const renderImage = () => {
    if (getVenueImage(venue)) {
      return <img src={getVenueImage(venue)} alt={venue.name} />;
    }
    return (
      <div className="venue__image">
        <div>
          {t('shared.image')}
          <br />
          {t('shared.coming_soon')}
        </div>
      </div>
    );
  };

  return (
    <li className="favourite" data-testid="favouriteVenue">
      <div className="favourite__image">{renderImage()}</div>
      <div className="favourite__inner">
        <div className="favourite__header">
          <h4 className="favourite__title">
            <Link href={`properties/${venue.id}`}>{venue.name}</Link>
          </h4>
          <button
            onClick={onRemove}
            className="favourite__remove"
            data-testid="removeFavouriteButton"
          >
            <ReactSVG src="/images/icons/accounts/remove.svg" />
          </button>
        </div>

        <div className="favourite__details">
          <Link href={`properties/${venue.id}`}>
            {t('favourite.view_property_details')}
          </Link>
          <button
            onClick={onBookNow}
            className="button button--primary button--small"
            data-testid="onBookNow"
          >
            {t('shared.book_now')}
          </button>
        </div>
      </div>
    </li>
  );
};

export default FavouriteVenue;
